import {Avatar, Badge, Box, Drawer, Grid, Link, MenuItem, Select, Stack, TextField, Typography} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import CustomBreadcrumbs from "@/components/breadcrumbs/CustomBreadcrumbs";
import {useTranslation} from "react-i18next";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import Button from "@mui/material/Button";
import StepLabel from "@mui/material/StepLabel";
import {HREndpoints} from "@/services/hr/endpoints";
import WebURL from "@/urls";
import CustomDataGrid, {
  DataGridRef,
} from "@/components/data-grid/CustomDataGrid";
import {
  GridColDef, GridColTypeDef,
  GridRenderCellParams,
  GridSelectionModel,
} from "@mui/x-data-grid";
import SnackbarUtil from "@/utils/SnackbarUtil";
import {DMSEndpoints} from "@/services/dms/endpoints";
import {ATTEndpoints} from "@/services/att/endpoints";
import {object, string, TypeOf, z} from "zod";
import {Controller, useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {ngteco_timezones} from "@/components/resource/timezone";
import GenericService from "@/services/GenericService";
import {LocationEndpoints} from "@/services/location/endpoints";
import ControlledTextFiled from "@/components/ngteco-hook-form/ControlledTextFiled";
import ControlAutoComplete from "@/components/hook-form/ControlAutoComplete";
import DepartmentDelete from "@/pages/quick/components/department/DepartmentDelete";
import SiteDelete from "@/pages/quick/components/site/SiteDelete";
import EmpDelete from "@/pages/quick/components/employee/EmployeeDelete";
import TimeSheetAdd from "@/pages/quick/components/timesheet/TimeSheetAdd";
import ScheduleAdd from "@/pages/quick/components/schedule/ScheduleAdd";
import {getOrganSites} from "@/store/slices/Site";
import ScheduleDelete from "@/pages/quick/components/schedule/ScheduleDelete";
import TimesheetDelete from "@/pages/quick/components/timesheet/TimesheetDelete";
import TimesheetEdit from "@/pages/quick/components/timesheet/TimesheetEdit";
import ScheduleEdit from "@/pages/quick/components/schedule/ScheduleEdit";
import {getOrganDevice} from "@/store/slices/Device";
import {StepIconProps} from "@mui/material/StepIcon";
import CheckIcon from "@mui/icons-material/Check";
import img_quick_start_bg from "@/assets/quick_start/img_quick_start_bg.png";
import {
  CustomTypography,
  ColorlibStepIconRoot,
  BgBox,
} from "./components/commonCompents";
import NGInputLabel from "@/components/ngteco-form/NGInputLabel";
import DepartmentView from "@/pages/hr/Department/components/DepartmentView";
import {ReactComponent as IconEdit} from "@/assets/icons/IconEdit.svg";
import CustomRowButton from "@/components/data-grid/CustomRowButton";
import EmployeeView from "@/pages/hr/Employee/components/EmployeeView";
import EmployeeNew from "@/pages/hr/Employee/components/EmployeeNew";
import DeviceService from "@/services/dms/DeviceService";
import SiteView from "@/pages/location/Site/components/SiteView";
import {ReactComponent as DeviceIcon} from "@/assets/images/Device.svg";
import ActionButton from "@/components/actions/ActionButton";
import CountryService from "@/services/cis/CountryService";
import ScheduleService from "@/services/att/services/ScheduleService";
import Switch from "@mui/material/Switch";
import UserService from "@/services/auth/UserService";
import SubscriptionService from "@/services/subscription/SubscriptionService";
import {ReactComponent as AppAccessEnableIcon} from "@/assets/person/AppAccessEnable.svg";
import {ReactComponent as AppAccessDisableIcon} from "@/assets/person/AppAccessDisable.svg";

const QuickStart: React.FC = () => {
  const {t} = useTranslation();
  // bd12a5cb47ff48c89886327edfc082ca   8098231240010
  const steps = [
    t("common.Site"),
    // t("common.Zone"),
    t("common.Device Management"),
    t("common.Add Employee"),
    t("common.Timesheet"),
    t("common.Shift Schedule"),
    t("common.Sync Employee"),
  ];
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const [country, setCountry] = React.useState<string>("USA");
  const [getDeviceId, setGetDeviceId] = React.useState<string>("");
  const [saving, setSaving] = React.useState<boolean>(false);
  const [gridData, setGridData] = useState([]);
  const [selectionDeptModel, setSelectionDeptModel] =
    useState<GridSelectionModel>([]);
  const [selectionEmpModel, setSelectionEmpModel] =
    useState<GridSelectionModel>([]);
  const [selectionSiteModel, setSelectionSiteModel] =
    useState<GridSelectionModel>([]);
  const [selectionScheduleModel, setSelectionScheduleModel] =
    useState<GridSelectionModel>([]);
  const [selectionTimesheetModel, setSelectionTimesheetModel] =
    useState<GridSelectionModel>([]);
  const departmentViewRef = useRef<any>({})
  const siteViewRef = useRef<any>({})
  const dataSiteGridRef = useRef<DataGridRef>();
  const dataDeptGridRef = useRef<DataGridRef>();
  const dataEmpGridRef = useRef<DataGridRef>();
  const dataTimesheetGridRef = useRef<DataGridRef>();
  const dataScheduleGridRef = useRef<DataGridRef>();
  const employeeViewRef = useRef<any>({})
  const employeeDelRef = useRef<any>({})
  const employeeNewRef = useRef<any>({})
  const deptDelRef = useRef<any>({})
  const siteDelRef = useRef<any>({})
  const timesheetRef = useRef<any>({})
  const scheduleRef = useRef<any>({})
  const allow_step = useRef<any>([])
  const sites: { id: string; name: string; address: Record<string, any> }[] =
    useSelector((state: any) => state.site.sites);
  const reloadSiteTable = () => {
    dataSiteGridRef.current?.refresh();
  }
  const reloadDeptTable = () => {
    dataDeptGridRef.current?.refresh();
  }
  const reloadEmpTable = () => {
    dataEmpGridRef.current?.refresh();
  }
  const reloadTimesheetTable = () => {
    dataTimesheetGridRef.current?.refresh();
  }
  const reloadScheduleTable = () => {
    dataScheduleGridRef.current?.refresh();
  }
  const timezoneList = ngteco_timezones();
  const siteSchema = object({
    site_name: z
      .string()
      .min(1, t("common.This field is required!"))
      .max(
        30,
        t("common.The length of field cannot exceed digits", {number: 30})
      ),
    // time_zone: z.object(
    //   {
    //     value: z.string(),
    //     name: string(),
    //   },
    //   {
    //     required_error: t("common.This field is required!"),
    //     invalid_type_error: t("common.This field is required!"),
    //   }
    // ),
    time_zone: z.string({required_error: t("common.This field is required!")}),
    country: z.string().min(1, t("common.This field is required!")),
    dst_key: z.boolean().optional(),
  });
  type siteInput = TypeOf<typeof siteSchema>;
  const siteForm = useForm<siteInput>({
    resolver: zodResolver(siteSchema),
    defaultValues: {
      site_name: "",
    },
  });
  const dispatch = useDispatch();
  const timezoneCol: GridColTypeDef = {
    type: "string",
    flex: 0.3,
    minWidth: 320,
    valueGetter: value => value.row.address.timeZone_format,
    renderCell: (params) => {
      const timezone = params.row.address.timeZone_format
      if (!timezone) {
        return '-'
      }
      return timezone
    }
  }
  const [countryList, setCountryList] = useState({"USA": ""})
  const [timezoneDict, setTimezoneDict] = useState([])
  const [dstKey, setDstKey] = useState<string>('')
  const [countryCode, setCountryCode] = useState<Record<string, string>>({})
  const country_code = useRef('')
  const [paymentStatus, setPaymentStatus] = React.useState<any>("");
  useEffect(() => {
    CountryService.getCountryList().then((result) => {
      const countries = result.data.data?.countries
      const result_dict = countries.reduce((obj: any, country: any) => {
        obj[country.name] = country.name;
        return obj;
      }, {});
      const code_dict = countries.reduce((obj: any, country: any) => {
        obj[country.name] = country.iso31661Cd2;
        return obj;
      }, {} as Record<string, string>);
      setCountryList(result_dict)
      setCountryCode(code_dict)
    })
    SubscriptionService.getPaymentStatus().then((res: any) => {
      if (res.status < 400) {
        setPaymentStatus(res.data?.data?.subscription_status)
      }
    })
  }, [])
  useEffect(() => {
    if (country_code.current) {
      UserService.getTimezoneByCountry({'iso31661Cd2': country_code.current}).then((res => {
        setTimezoneDict(res.data?.data.timezone_dict)
      }))
    }
  }, [country])
  type CountryType = typeof countryList;
  const site_columns: GridColDef[] = [
    {field: 'name', headerName: t("common.Site Name"), type: "string", minWidth: 120, flex: 0.2},
    {field: 'timezone', headerName: t("common.Site Time Zone"), ...timezoneCol},
    // {field: 'description', headerName: t("common.Description"), type: "string", minWidth: 200, flex: 0.2},
    {
      field: 'country', headerName: t("signUp.Country or Region"), type: "string", minWidth: 50, flex: 0.2,
      align: 'center',
      renderCell: (params) => {
        const country: keyof CountryType = params.row.country;
        return (
          <Box>{countryList[country]}</Box>
        )
      }
    },
    {
      field: 'dayLightSaving', headerName: t("common.DST"), type: "string", minWidth: 50, flex: 0.1, sortable: false,
      renderCell: (params) => {
        return (
          <Box>{params.row.address.dayLightSaving ? "True" : "False"}</Box>
        )
      }
    },
    {
      field: 'actions', flex: 0.2, headerName: t("common.action"), headerAlign: 'left', align: 'left', sortable: false,
      renderCell: (cell) => {
        return (
          <Stack direction={"row"}>
            <Grid sx={{marginLeft: "-5px"}}>
              <CustomRowButton insideSvgIcon={IconEdit} actionName={t("common.edit")} buttonProps={{
                key: "edit",
                onClick: () => {
                  siteViewRef?.current?.showDetail(cell.row.id)
                  // navigate(WebURL.LOCATION_SITE_EDIT, {state: {id: cell.row.id}});
                }
              }}/>
            </Grid>
          </Stack>
        )
      }
    },
  ]
  const StatusField = (params: GridRenderCellParams) => {
    if (params.value === "1") {
      return <strong style={{color: "#006644"}}>{t("dms.Online")}</strong>;
    } else {
      return <strong style={{color: "#BF2600"}}>{t("dms.Offline")}</strong>;
    }
  };
  const device_columns: GridColDef[] = [
    {
      field: "alias",
      headerName: t("common.Device name"),
      minWidth: 200,
      flex: 0.2,
      renderCell: (params) => {
        return (
          <Grid style={{display: "flex", alignItems: "center"}}>
            <Badge
              color="success"
              badgeContent=""
              variant="dot"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              sx={{
                ".MuiBadge-badge": {
                  backgroundColor:
                    params.row.status === "1" ? "#20cf61" : "#ef5656",
                  bottom: "7px",
                  right: "7px",
                  border: `3px solid #fff`,
                  height: "15px",
                  width: "15px",
                  minWidth: "15px",
                  borderRadius: "15px",
                },
              }}
            >
              <DeviceIcon/>
            </Badge>
            <Box style={{padding: "0 20px"}}>{params.row.alias}</Box>
          </Grid>
        );
      },
    },
    {field: "sn", headerName: t("common.SN"), flex: 0.2},
    {field: "site_name", headerName: t("common.Site name"), flex: 0.2},
    {
      field: "status",
      renderCell: StatusField,
      headerName: t("dms.Status"),
      minWidth: 70,
      flex: 0.1,
    },
    {
      field: "user_count",
      headerName: t("dms.user count"),
      minWidth: 100,
      flex: 0.1,
    },
    {
      field: "actions",
      hideSortIcons: true,
      flex: 0.2,
      minWidth: 500,
      headerName: t("common.action"),
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (cell) => {
        return (
          <Stack direction={"row"}>
            <ActionButton
              title={t("common.sync")}
              icon="icon-ic_syncperson"
              disabled={cell.row.status === '0'}
              handleClick={() =>
                DeviceService.SyncAllEmployees(cell.row.id).then((result) => {
                  SnackbarUtil.success(t("common.Successful synchronized persons", {value: result?.data?.data.successCount}));
                })
              }
            ></ActionButton>
          </Stack>
        )
      }
    },
  ];

  const department_columns: GridColDef[] = [
    {field: "name", headerName: t("common.Department Name"), minWidth: 150},
    {field: "code", headerName: t("common.Department Code"), minWidth: 150},
    {
      field: "actions",
      headerName: t("common.action"),
      headerAlign: "left",
      align: "left",
      minWidth: 100,
      sortable: false,
      renderCell: (e) => {
        return (
          <Stack direction={"row"} sx={{marginLeft: "-5px"}}>
            <Grid sx={{marginRight: "20px", display: "flex"}}>
              <CustomRowButton
                insideSvgIcon={IconEdit}
                actionName={t("common.edit")}
                buttonProps={{
                  key: "edit",
                  onClick: () => {
                    departmentViewRef?.current?.showDetail(e.id)
                    // navigate(WebURL.HR_DEPARTMENT_VIEW, {state: {id: e.id}});
                  }
                }}
              />
            </Grid>
          </Stack>
        );
      },
    },
  ];
  const AppAccessField = (params: GridRenderCellParams) => {
    if (paymentStatus) {
      if (params.value) {
        return <AppAccessEnableIcon/>;
      } else {
        return <AppAccessDisableIcon/>;
      }
    } else {
      return ''
    }
  };
  const emp_columns: GridColDef[] = [
    {
      field: "firstName",
      headerName: t("common.Person Name"),
      flex: 0.1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <Grid style={{display: "flex", alignItems: "center"}}>
            <Box style={{padding: "0 8px"}}>
              {params.row.firstName} {params.row.lastName}
            </Box>
          </Grid>
        );
      },
    },
    {
      field: "employeeCode",
      headerName: t("common.Person ID"),
      flex: 0.1,
      type: "string",
      minWidth: 150,
    },
    {field: 'email', headerName: t("common.Email"), type: "string", flex: 0.1, minWidth: 100,},
    {
      field: "department_name",
      headerName: t("common.Department"),
      flex: 0.1,
      type: "string",
      minWidth: 150,
    },
    {
      field: 'verify',
      headerName: !paymentStatus ? "" : t("common.App Access"),
      type: "string",
      flex: !paymentStatus ? 0 : 0.1,
      minWidth: !paymentStatus ? 0 : 50,
      renderCell: AppAccessField,
      align: 'center'
    },
    {
      field: "actions",
      headerName: t("common.action"),
      headerAlign: "left",
      align: "left",
      flex: 0.1,
      minWidth: 50,
      sortable: false,
      renderCell: (e) => {
        return (
          <Stack direction={"row"} sx={{marginLeft: "-5px"}}>
            <Grid>
              <CustomRowButton insideSvgIcon={IconEdit} actionName={t("common.edit")} buttonProps={{
                key: "edit",
                onClick: () => {
                  employeeViewRef?.current?.showDetail(e.row.id)
                  // navigate(WebURL.HR_EMPLOYEE_VIEW, {state: {id: e.row.id}});
                }
              }}/>
            </Grid>
          </Stack>
        );
      },
    },
  ];
  const timesheet_columns: GridColDef[] = [
    {field: "name", headerName: t("common.Timesheet Name"), minWidth: 200},
    {field: "period", headerName: t("common.Unit"), minWidth: 180},
    {field: "cycle", headerName: t("common.Cycle"), minWidth: 180},
    {
      field: "description",
      headerName: t("common.Description"),
      type: "string",
      minWidth: 100,
    },
    {
      field: 'timesheet_color',
      headerName: t("common.Timesheet Color"),
      type: "string",
      minWidth: 100,
      // flex: 0.2,
      renderCell: (params) => {
        // 获取颜色值，默认使用灰色作为备选
        const color = params.value || '';

        return (
          <Grid container style={{display: "flex", alignItems: "center"}}>
            {/* 彩色圆形展示颜色 */}
            {color && <Box
              style={{
                width: '20px',
                height: '20px',
                // borderRadius: '50%',
                backgroundColor: color,
                border: '1px solid #e0e0e0',
                margin: '0 8px'
              }}
            />}
            {/* 可选：显示颜色的十六进制值 */}
            {/*  <span style={{fontSize: '12px', color: '#666'}}>*/}
            {/*  {color}*/}
            {/*</span>*/}
          </Grid>
        );
      }
    },
    {
      field: "actions",
      headerName: t("common.action"),
      headerAlign: "left",
      align: "left",
      minWidth: 100,
      sortable: false,
      renderCell: (e) => {
        return (
          <Stack direction={"row"}>
            <Grid sx={{marginLeft: "-5px"}}>
              <TimesheetEdit timesheetId={e.id.toString()}/>
            </Grid>
          </Stack>
        );
      },
    },
  ];
  const schedule_columns: GridColDef[] = [
    {field: "employee_name", headerName: t("common.Name"), minWidth: 150},
    {
      field: "employee_code",
      headerName: t("hr.employee.Person ID"),
      minWidth: 100,
    },
    {
      field: "department_name",
      headerName: t("hr.department.Department"),
      minWidth: 100,
    },
    {
      field: "timesheet_name",
      headerName: t("att.schedule.Timesheet"),
      minWidth: 100,
    },
    {
      field: "assigned_start",
      headerName: t("att.schedule.Start Date"),
      type: "date",
      minWidth: 80,
    },
    {
      field: "assigned_end",
      headerName: t("att.schedule.End Date"),
      type: "date",
      minWidth: 80,
    },
    {field: 'timezone', headerName: t("att.schedule.TimeZone"), flex: 0.5},
    {
      field: "actions",
      headerName: t("common.action"),
      headerAlign: "left",
      align: "left",
      minWidth: 50,
      sortable: false,
      renderCell: (e) => {
        return (
          <Stack direction={"row"}>
            <Grid sx={{marginLeft: "-5px"}}>
              <ScheduleEdit scheduleId={e.id.toString()}/>
            </Grid>
          </Stack>
        );
      },
    },
  ];
  const deviceSchema = object({
    sn: z.string().min(1, t("common.This field is required!")),
    site: z.object(
      {
        id: z.string(),
        name: z.string(),
        address: z.object({
          timeZone: z.string().nullish(),
          city: z.string().nullish(),
          dayLightSaving: z.boolean().optional(),
        }),
      },
      {
        required_error: t("common.This field is required!"),
        invalid_type_error: t("common.This field is required!"),
      }
    ),
  });
  type deviceType = TypeOf<typeof deviceSchema>;
  const deviceForm = useForm<deviceType>({
    resolver: zodResolver(deviceSchema),
  });
  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleSkip = () => {
    let newSkipped = skipped;
    if (activeStep === 0) {
      dispatch<any>(getOrganSites());
    }
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    if (!allow_step.current.includes(activeStep)) {
      allow_step.current.push(activeStep)
    }
    if (!allow_step.current.includes(activeStep + 1)) {
      allow_step.current.push(activeStep + 1)
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (activeStep === 1) {
      if (!getDeviceId) {
        SnackbarUtil.error(t("common.device sn error"), {
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
        return false;
      }
    }
    if (activeStep === 2) {
      dispatch<any>(getOrganDevice());
    }
    if (activeStep === 4) {
      ScheduleService.list().then((res) => {
        const total = res.data.total
        if (total === 0) {
          SnackbarUtil.error(t("common.Add schedule first"), {
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
          return false;
        } else {
          if (!allow_step.current.includes(activeStep)) {
            allow_step.current.push(activeStep)
          }
          if (!allow_step.current.includes(activeStep + 1)) {
            allow_step.current.push(activeStep + 1)
          }
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setSkipped(newSkipped);
        }
      })
    } else {
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }

      if (!allow_step.current.includes(activeStep)) {
        allow_step.current.push(activeStep)
      }
      if (!allow_step.current.includes(activeStep + 1)) {
        allow_step.current.push(activeStep + 1)
      }
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
    }
  };

  const handleNextOne = async (type: any) => {
    let newSkipped = skipped;
    const values = siteForm.getValues();
    siteForm.setValue('country', country)
    const isValid = await siteForm.trigger();
    if (!isValid) {
      SnackbarUtil.error(t('common.quickly setting site value error'), {
        anchorOrigin: {vertical: "top", horizontal: "center"},
      });
      return
    }
    try {
      if (isValid) {
        const newSite = {
          name: values.site_name,
          address: {
            timeZone: values.time_zone,
            city: dstKey,
            addressLine1: "default",
            country: country,
            dayLightSaving: values.dst_key || false,
          },
        };
        GenericService.create(LocationEndpoints.SITE_URI_V2, newSite).then(
          (response) => {
            if (response?.status >= 400) {
              SnackbarUtil.error(response?.message, {
                anchorOrigin: {vertical: "top", horizontal: "center"},
              });
            } else {
              SnackbarUtil.success(t("common.Site added successfully."), {
                anchorOrigin: {vertical: "top", horizontal: "center"},
              });
              if (isStepSkipped(activeStep)) {
                newSkipped = new Set(newSkipped.values());
                newSkipped.delete(activeStep);
              }
              if (type === "next") {
                if (!allow_step.current.includes(activeStep)) {
                  allow_step.current.push(activeStep)
                }
                if (!allow_step.current.includes(activeStep + 1)) {
                  allow_step.current.push(activeStep + 1)
                }
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                setSkipped(newSkipped);
              } else {
                reloadSiteTable()
              }
            }
          }
        );
      }
    } catch (e) {
      console.log("error===", e);
    } finally {
      setSaving(false);
      dispatch<any>(getOrganSites());
      siteForm.reset({
        site_name: '',
        time_zone: undefined, // 或根据默认值设置为 null
        country: '',
      });
      setCountry('')
    }
    dispatch<any>(getOrganSites());
    setDstKey('')
  };
  const handleNextSecond = async () => {
    let newSkipped = skipped;
    const isValid = await deviceForm.trigger()
    const values = deviceForm.getValues();
    if (!isValid) {
      SnackbarUtil.error(t('common.Site or Device SN has no value'), {
        anchorOrigin: {vertical: "top", horizontal: "center"},
      });
    }
    try {
      if (isValid) {
        const origin = {
          ...values,
          siteId: values.site.id,
          registrationDevice: 0,
          deviceAlias: values.sn,
          dstKey: values.site.address?.city || "ngteco",
          dst_key: values.site.address?.dayLightSaving || false
        };
        await DeviceService.deviceBinding(
          origin
        ).then((res) => {
          if (res.status < 400) {
            SnackbarUtil.success(t("common.persons is synchronizing"))
          } else {
            SnackbarUtil.error(res.data?.message)
          }
        });
        if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values());
          newSkipped.delete(activeStep);
        }
        if (!allow_step.current.includes(activeStep)) {
          allow_step.current.push(activeStep)
        }
        if (!allow_step.current.includes(activeStep + 1)) {
          allow_step.current.push(activeStep + 1)
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
      }
    } catch (e) {
      console.log("error===", e);
    } finally {
      setSaving(false);
      deviceForm.reset()
    }
  };

  const handleBack = () => {
    if (activeStep == 2) {
      setGetDeviceId("");
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    setGetDeviceId("");
  };

  const handleDataGridSave = (value: any) => {
    if (value) {
      setGridData(value);
    }
  };

  function ColorlibStepIcon(props: StepIconProps) {
    const {active, completed, className} = props;
    return (
      <Grid
        sx={{
          width: "48px",
          height: "48px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Grid
          sx={{
            width: active ? "48px" : "38px",
            height: active ? "48px" : "38px",
            borderRadius: "48px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor:
              active || completed
                ? "rgba(43, 169, 222, 0.1)"
                : "rgba(143, 156, 163, 0.2)",
          }}
        >
          <ColorlibStepIconRoot
            ownerState={{completed, active}}
            className={className}
          >
            <Grid
              sx={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#ffffff",
              }}
            >
              {completed ? <CheckIcon/> : props.icon}
            </Grid>
          </ColorlibStepIconRoot>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid sx={{
      position: 'relative',

    }}>
      <CustomBreadcrumbs record={[{label: activeStep === 1 ? t("common.Device Management") : t("common.Quick Start")}]}/>
      <Grid
        sx={{
          backgroundColor: "#ffffff",
          minHeight: "calc(100vh - 130px)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          marginRight: "24px",
          paddingBottom: "60px",
          position: "relative",
          marginBottom: "24px"
        }}
      >
        <Grid
          sx={{
            padding: "10px 14px 6px 14px",
          }}
        >
          <Stepper alternativeLabel activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step
                  key={label}
                  {...stepProps}
                  sx={{
                    ".MuiStepConnector-root": {
                      top: "24px",
                      height: "2px",
                      background: "#E9EBED",
                    },
                  }}
                  onClick={() => {
                    if (allow_step.current.includes(index)) {
                      setActiveStep(index)
                    }
                  }}
                >
                  <StepLabel
                    sx={{
                      ".MuiStepLabel-label": {
                        marginTop: "6px !important",
                        color: "#ABB5BA",
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                      },
                      ".Mui-active": {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "#2BA9DE !important",
                      },
                      ".Mui-completed": {
                        color: "#ABB5BA !important",
                      },
                    }}
                    StepIconComponent={ColorlibStepIcon}
                    {...labelProps}
                  >
                    {label}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>

          <Grid
            sx={{
              height: "10px",
            }}
          ></Grid>

          {activeStep === steps.length ? (
            <React.Fragment>
              <BgBox>
                <Typography sx={{mt: 2, mb: 1}}>
                  {t("common.all steps completed")}
                </Typography>
              </BgBox>

              <Box sx={{display: "flex", flexDirection: "row", pt: 2}}>
                <Box sx={{flex: "1 1 auto"}}/>
                <Button onClick={handleReset}>{t("common.Return to the first page")}</Button>
              </Box>
            </React.Fragment>
          ) : (
            <React.Fragment>

              {activeStep === 0 && (
                <Grid>
                  <Grid
                    sx={{
                      padding: "20px",
                      backgroundImage: "url(" + img_quick_start_bg + ")",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "16px !important",
                        fontWeight: "bold !important",
                      }}
                    >
                      {t("common.Create A New Site")}
                    </Typography>
                    <CustomTypography>{t("common.Guide")}</CustomTypography>
                    <CustomTypography>
                      {t("common.quickly setting site one")}
                    </CustomTypography>
                    <CustomTypography>
                      {t("common.quickly setting site two")}
                    </CustomTypography>
                    <CustomTypography>
                      {t("common.quickly setting site three")}
                    </CustomTypography>
                  </Grid>

                  <Grid
                    sx={{
                      mt: 2,
                      display: "flex",
                      width: "100%",
                    }}
                  >
                    <Grid
                      sx={{
                        mr: 2,
                        flexGrow: 1,
                        maxWidth: "600px !important",
                      }}
                      xs={3}
                    >
                      {/*<h3>{t("common.Site information")}</h3>*/}
                      <Grid
                        sx={{
                          mb: 1,
                        }}
                      >
                        {t("common.Site information")}
                      </Grid>
                      <ControlledTextFiled
                        fullWidth
                        label={t("common.Site Name")}
                        name={"site_name"}
                        required={true}
                        hookForm={siteForm}
                      />
                      <NGInputLabel label={t("signUp.Country or Region")} required/>
                      <Select
                        id="country-select"
                        fullWidth
                        value={country}
                        onChange={(event) => {
                          setCountry(event.target.value)
                          country_code.current = countryCode[event.target.value]
                        }}
                      >
                        {Object.entries(countryList).map(([value, label]) => (
                          <MenuItem key={value} value={value}>
                            {label}
                          </MenuItem>
                        ))}
                      </Select>
                      <Stack sx={{lineHeight: "5vh"}}>
                        <NGInputLabel label={t("common.Site Time Zone")} required={true}/>
                        <Select
                          id="select_timezone"
                          fullWidth
                          required={true}
                          value={dstKey}
                          onChange={(event) => {
                            setDstKey(event.target.value)
                            siteForm.setValue("time_zone", event.target.value)
                          }}
                        >
                          {Object.entries(timezoneDict).map(([value, label]) => (
                            <MenuItem key={value} value={value}>
                              {label}
                            </MenuItem>
                          ))}
                        </Select>
                      </Stack>
                      <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <NGInputLabel label={t("common.Daylight Saving Time")}/>
                        <Controller
                          name="dst_key"
                          control={siteForm.control}
                          render={({field}) => {
                            return (
                              <Switch
                                {...field}
                                checked={field.value ?? false}
                                onChange={(e) => field.onChange(e.target.checked)}
                                color="primary"
                              />
                            );
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid sx={{maxWidth: "150px"}} xs={2}></Grid>
                    <Grid
                      sx={{
                        mr: 2,
                        flexGrow: 1,
                        maxWidth: "1000px !important",
                        minWidth: "680px !important",
                      }}
                      xs={7}
                    >
                      <Grid
                        sx={{
                          mb: 1,
                        }}
                      >
                        {t("common.Site")}
                      </Grid>
                      <CustomDataGrid
                        height="40vh"
                        boxShadow={false}
                        containerStyle={{
                          padding: "0px",
                        }}
                        tableStyle={{
                          padding: "0px",
                        }}
                        rowHeight={40}
                        headerHeight={40}
                        uri={LocationEndpoints.SITE_URI_V2}
                        columns={site_columns}
                        ref={dataSiteGridRef}
                        checkboxSelection={true}
                        onDataChange={handleDataGridSave}
                        onSelectionModelChange={(ids) => {
                          setSelectionSiteModel(ids);
                          siteDelRef?.current?.showDelete(ids)
                        }}
                        selectionModel={selectionSiteModel}
                        toolbar={{
                          title: "",
                          searchTips: t("location.site.Search by Site Name"),
                          breadcrumbs: [
                            {
                              breadcrumbName: t("common.Site"),
                              path: WebURL.LOCATION_SITE,
                            },
                          ],
                          extraComponentOnRight: (
                            <Grid>
                              <SiteDelete ref={siteDelRef} reloadTable={reloadSiteTable}/>
                              <SiteView ref={siteViewRef} reloadTable={reloadSiteTable}/>
                            </Grid>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {activeStep === 1 && (
                <Grid>
                  <BgBox>
                    <Typography>{t("dms.tip04")}</Typography>
                    <CustomTypography>{t("dms.tip05")}</CustomTypography>
                    <CustomTypography>{t("dms.tip06")}</CustomTypography>
                    <CustomTypography>{t("dms.tip07")}</CustomTypography>
                    <CustomTypography>{t("dms.tip08")}</CustomTypography>
                    <CustomTypography>{t("dms.tip09")}</CustomTypography>
                  </BgBox>

                  <Box component={"form"}
                       sx={{
                         mt: 2,
                         display: "flex",
                         width: "100%",
                         height: "90%"
                       }}>
                    <Grid container>
                      <Grid
                        sx={{
                          mr: 2,
                          flexGrow: 1,
                          maxWidth: "600px !important",
                        }}
                      >
                        {/*<h3>{t("common.Add A New Device")}</h3>*/}
                        <Grid
                          sx={{
                            mb: 1,
                          }}
                        >
                          {t("common.Add A New Device")}
                        </Grid>
                        <Grid xs={6} item>
                          <Box component={"form"}>
                            <Stack sx={{lineHeight: "5vh"}}>
                              <ControlAutoComplete
                                key={deviceForm.getValues('site')?.id || 'initial'}
                                label={t("dms.Bind Site")}
                                name={"site"}
                                form={deviceForm}
                                required={true}
                                options={sites}
                              />
                            </Stack>
                          </Box>
                        </Grid>
                        <Grid xs={6}>
                          <Typography
                            sx={{
                              fontSize: "14px !important",
                              color: "#666666 !important ",
                              marginBottom: '8px'
                            }}
                          >
                            {t("dms.Enter device SN")}
                          </Typography>
                          <TextField
                            required
                            autoFocus
                            variant="outlined"
                            size={"small"}
                            sx={{minWidth: "300px"}}
                            fullWidth
                            error={!!deviceForm.formState.errors["sn"]}
                            helperText={deviceForm.formState.errors["sn"]?.message || ""}
                            {...deviceForm.register("sn")}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              )}

              {activeStep === 2 && (
                <Grid>
                  <BgBox>
                    <Typography>{t("common.Add new employees and department")}</Typography>
                    <CustomTypography
                      sx={{
                        marginBottom: "0px  !important",
                      }}
                    >
                      {t("common.quickly setting device one")}
                    </CustomTypography>
                  </BgBox>

                  <Grid
                    sx={{
                      mt: 2,
                      display: "flex",
                      width: "100%",
                    }}
                  >
                    <Grid
                      sx={{
                        mr: 2,
                        flexGrow: 1,
                        maxWidth: "600px !important",
                      }}
                    >
                      <Grid
                        sx={{
                          mb: 1,
                        }}
                      >
                        {t("common.Department")}
                      </Grid>
                      <CustomDataGrid
                        containerStyle={{
                          padding: "0px",
                        }}
                        tableStyle={{
                          padding: "0px",
                        }}
                        rowHeight={40}
                        headerHeight={40}
                        height="55vh"
                        ref={dataDeptGridRef}
                        boxShadow={false}
                        uri={HREndpoints.HR_DEPARTMENT_URI}
                        columns={department_columns}
                        checkboxSelection={true}
                        onDataChange={handleDataGridSave}
                        onSelectionModelChange={(ids) => {
                          setSelectionDeptModel(ids);
                          deptDelRef?.current?.showDelete(ids)
                        }}
                        selectionModel={selectionDeptModel}
                        toolbar={{
                          title: t("common.Department"),
                          search: true,
                          searchTips: t(
                            "common.Search by Department Name, Department Code"
                          ),
                          actions: [{
                            key: 'add', iconFont: 'icon-ic_add', helpTxt: t("common.add"), callback: async () => {
                              departmentViewRef?.current?.showDetail()
                              // navigate(WebURL.HR_DEPARTMENT_NEW);
                            }
                          }],
                          extraComponentOnRight: (
                            <Grid
                              sx={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <DepartmentDelete ref={deptDelRef} reloadTable={reloadDeptTable}/>
                              <DepartmentView ref={departmentViewRef} reloadTable={reloadDeptTable}></DepartmentView>
                            </Grid>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid
                      sx={{
                        ml: 2,
                        flexGrow: 1,
                      }}
                    >
                      <Grid
                        sx={{
                          mb: 1,
                        }}
                      >
                        {t("common.Person")}
                      </Grid>
                      <CustomDataGrid
                        height="55vh"
                        containerStyle={{
                          padding: "0px",
                        }}
                        tableStyle={{
                          padding: "0px",
                        }}
                        boxShadow={false}
                        rowHeight={40}
                        headerHeight={40}
                        uri={HREndpoints.HR_EMPLOYEE_URI}
                        columns={emp_columns}
                        ref={dataEmpGridRef}
                        checkboxSelection={true}
                        onDataChange={handleDataGridSave}
                        onSelectionModelChange={(ids) => {
                          setSelectionEmpModel(ids);
                          employeeDelRef?.current?.showDelete(ids)
                        }}
                        selectionModel={selectionEmpModel}
                        toolbar={{
                          title: t("common.Person"),
                          search: true,
                          searchTips: t("common.Search by Person First Name"),
                          actions: [{
                            key: 'add', iconFont: 'icon-ic_add', helpTxt: t("common.add"), callback: async () => {
                              employeeNewRef?.current?.showAdd()
                              // navigate(WebURL.HR_EMPLOYEE_NEW);
                            }
                          }],
                          breadcrumbs: [
                            {
                              breadcrumbName: t("common.Add Employee"),
                              path: '',
                            },
                          ],
                          extraComponentOnRight: (
                            <Grid
                              sx={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <EmpDelete ref={employeeDelRef} reloadTable={reloadEmpTable}/>
                              <EmployeeView ref={employeeViewRef} reloadTable={reloadEmpTable} paymentStatus={paymentStatus}></EmployeeView>
                              <EmployeeNew ref={employeeNewRef} reloadTable={reloadEmpTable} paymentStatus={paymentStatus}></EmployeeNew>
                            </Grid>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {activeStep === 5 && (
                <Grid>
                  <BgBox
                    style={{
                      paddingBottom: "6px",
                      paddingTop: "6px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#333333",
                        fontSize: "16px !important",
                      }}
                    >
                      {t("common.Sync Employees to Your Device")}
                    </Typography>
                    <CustomTypography>
                      {t("common.quickly setting device five")}
                    </CustomTypography>
                    <CustomTypography>
                      {t("common.quickly setting device six")}
                    </CustomTypography>
                  </BgBox>
                  <Grid
                    sx={{
                      mt: 2,
                    }}
                  >
                    <CustomDataGrid
                      height="55vh"
                      boxShadow={false}
                      containerStyle={{
                        padding: "0px",
                      }}
                      tableStyle={{
                        padding: "0px",
                      }}
                      rowHeight={40}
                      headerHeight={40}
                      uri={DMSEndpoints.DMS_DEVICE_URI}
                      columns={device_columns}
                      checkboxSelection={true}
                      toolbar={{
                        title: t("common.Device"),
                        searchTips: t("dms.Search by Device SN"),
                        breadcrumbs: [
                          {
                            breadcrumbName: t("common.Sync Employee"),
                            path: '',
                          },
                        ],
                      }}
                    />
                  </Grid>
                </Grid>
              )}

              {activeStep === 3 && (
                <Grid>
                  <BgBox
                    style={{
                      paddingBottom: "6px",
                      paddingTop: "6px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#333333",
                        fontSize: "16px !important",
                      }}
                    >
                      {t("common.quickly setting timesheet one")}
                    </Typography>
                    <CustomTypography>{t("common.Guide")}</CustomTypography>
                    <CustomTypography>
                      {t("common.quickly setting timesheet two")}
                    </CustomTypography>
                    <CustomTypography>
                      {t("common.quickly setting timesheet three")}
                    </CustomTypography>
                  </BgBox>

                  <Grid
                    sx={{
                      mt: 2,
                    }}
                  >
                    <CustomDataGrid
                      height="50vh"
                      boxShadow={false}
                      containerStyle={{
                        padding: "0px",
                      }}
                      tableStyle={{
                        padding: "0px",
                      }}
                      rowHeight={40}
                      headerHeight={40}
                      uri={ATTEndpoints.ATT_TIMESHEET_URI}
                      columns={timesheet_columns}
                      ref={dataTimesheetGridRef}
                      checkboxSelection={true}
                      onSelectionModelChange={(newSelectionModel) => {
                        setSelectionTimesheetModel(newSelectionModel);
                        timesheetRef?.current?.showDelete(newSelectionModel)
                      }}
                      selectionModel={selectionTimesheetModel}
                      toolbar={{
                        title: "",
                        search: true,
                        searchTips: t("common.Search by Timesheet Name"),
                        breadcrumbs: [
                          {
                            breadcrumbName: t("common.TimeSheet"),
                            path: WebURL.ATT_TIMESHEET,
                          },
                        ],
                        extraComponentOnRight: (
                          <Grid
                            sx={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <TimeSheetAdd ref={timesheetRef} reloadTable={reloadTimesheetTable}/>
                            <TimesheetDelete ref={timesheetRef} reloadTable={reloadTimesheetTable}/>
                          </Grid>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              )}

              {activeStep === 4 && (
                <Grid>
                  <BgBox
                    style={{
                      paddingBottom: "6px",
                      paddingTop: "6px",
                    }}
                  >
                    <Typography>
                      {t("common.quickly setting schedule one")}
                    </Typography>
                    <CustomTypography>{t("common.Guide")}</CustomTypography>
                    <CustomTypography>
                      {t("common.quickly setting schedule two")}
                    </CustomTypography>
                  </BgBox>

                  <Grid
                    sx={{
                      marginTop: "16px",
                    }}
                  >
                    <CustomDataGrid
                      height="55vh"
                      boxShadow={false}
                      containerStyle={{
                        padding: "0px",
                      }}
                      tableStyle={{
                        padding: "0px",
                      }}
                      rowHeight={40}
                      headerHeight={40}
                      uri={ATTEndpoints.ATT_SCHEDULE_URI}
                      columns={schedule_columns}
                      ref={dataScheduleGridRef}
                      checkboxSelection={true}
                      onSelectionModelChange={(newSelectionModel) => {
                        setSelectionScheduleModel(newSelectionModel);
                        scheduleRef?.current?.showDelete(newSelectionModel)
                      }}
                      selectionModel={selectionScheduleModel}
                      toolbar={{
                        title: "",
                        search: true,
                        searchTips: t(
                          "common.Search by Person ID, Person Name, Timesheet Name"
                        ),
                        breadcrumbs: [
                          {
                            breadcrumbName: t("common.Shift Schedule"),
                            path: '',
                          },
                        ],
                        extraComponentOnRight: (
                          <Grid
                            sx={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <ScheduleAdd ref={scheduleRef} reloadTable={reloadScheduleTable}/>
                            <ScheduleDelete ref={scheduleRef} reloadTable={reloadScheduleTable}/>
                          </Grid>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              )}
            </React.Fragment>
          )}
        </Grid>
      </Grid>

      <Grid
        sx={{
          borderTop: "1px solid #F2F5F8",
          padding: "10px",
          display: "flex",
          justifyContent: "flex-start",
          position: "absolute",
          bottom: "0px",
          width: "calc(100% - 24px)",
          marginRight: "24px",
          boxSizing: 'border-box',
          backgroundColor: "#ffffff"
        }}
      >
        <Box sx={{display: "flex"}}>
          {activeStep === 0 && (
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
              <Link
                underline={"none"}
                onClick={handleSkip}
                sx={{
                  cursor: "pointer",
                  padding: "6 5px",
                  fontSize: "12px",
                  mb: 1  // 增加底部间距
                }}
              >
                {t("common.Already have a site? Skip this step")}
              </Link>

              <Box sx={{display: 'flex', gap: 2}}>
                <Button
                  onClick={() => handleNextOne('new')}
                  sx={{
                    color: "#ffffff",
                    fontSize: "14px",
                    fontWeight: 300,
                    background: "#2BA9DE",
                    "&:hover": {background: "#2BA9DE"},
                    textTransform: "none"
                  }}
                >
                  {activeStep === steps.length - 1 ? t("common.Finish") : t("common.Save and New")}
                </Button>
                <Button
                  onClick={() => handleNextOne('next')}
                  sx={{
                    color: "#ffffff",
                    fontSize: "14px",
                    fontWeight: 300,
                    background: "#2BA9DE",
                    "&:hover": {background: "#2BA9DE"},
                    textTransform: "none"
                  }}
                >
                  {activeStep === steps.length - 1 ? t("common.Finish") : t("common.Save and Next")}
                </Button>
              </Box>
            </Box>
          )}
          {activeStep === 1 && (
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
              <Link
                underline={"none"}
                onClick={handleSkip}
                sx={{
                  cursor: "pointer",
                  padding: "6 5px",
                  fontSize: "12px",
                  mb: 1  // 增加底部间距
                }}
              >
                {t("common.No need to add a new device? Skip this step")}
              </Link>
              <Box sx={{display: 'flex', gap: 2}}>
                <Button
                  onClick={handleBack}
                  sx={{
                    mr: 1,
                    color: "#ffffff",
                    fontSize: "14px",
                    fontWeight: 300,
                    background: "#2BA9DE",
                    "&:hover": {
                      background: "#2BA9DE",
                    },
                    textTransform: "none"
                  }}
                >
                  {t("common.Back")}
                </Button>
                <Button
                  onClick={handleNextSecond}
                  sx={{
                    mr: 1,
                    color: "#ffffff",
                    fontSize: "14px",
                    fontWeight: 300,
                    background: "#2BA9DE",
                    "&:hover": {
                      background: "#2BA9DE",
                    },
                    textTransform: "none"
                  }}
                >
                  {activeStep === steps.length - 1 ? t("common.Finish") : t("common.Next")}
                </Button>
              </Box>
            </Box>
          )}
          {[2, 3, 4, 5].includes(activeStep) && (
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
              <Link
                underline={"none"}
                onClick={handleSkip}
                sx={{
                  cursor: "pointer",
                  padding: "6 5px",
                  fontSize: "12px",
                  mb: 1  // 增加底部间距
                }}
              >
                {activeStep == 2 && t("common.No need to add employee? Skip this step")}
                {activeStep == 3 && t("common.No need to create a new timesheet? Skip this step")}
                {/*{activeStep == 4 && t("common.No need to create a new schedule? Skip this step")}*/}
              </Link>
              <Box sx={{display: 'flex', gap: 2}}>
                <Button
                  onClick={handleBack}
                  sx={{
                    mr: 1,
                    color: "#ffffff",
                    fontSize: "14px",
                    fontWeight: 300,
                    background: " #2BA9DE",
                    "&:hover": {
                      background: " #2BA9DE",
                    },
                    textTransform: "none"
                  }}
                >
                  {t("common.Back")}
                </Button>
                <Button
                  onClick={handleNext}
                  sx={{
                    mr: 1,
                    color: "#ffffff",
                    fontSize: "14px",
                    fontWeight: 300,
                    background: " #2BA9DE",
                    "&:hover": {
                      background: " #2BA9DE",
                    },
                    textTransform: "none"
                  }}
                >
                  {activeStep === steps.length - 1 ? t("common.Finish") : t("common.Next")}
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
export default QuickStart;
